import { api, makeApiRequest } from 'api/_init'
import { unwrapEnvelope } from 'domain/shared/envelope'
import { mapConversionGoalsResponse } from './mappers'

// Google-scoped (app/api/v4/integrations/connect/google/assets/assets.py:ConversionGoalsAPI)
// — customer_id is a URL path segment; campaign_type/bidding_strategy are the
// only real query params, both optional.
const googleConversionGoalsApi = {
  fetchConversionGoalsAsync: async (customerId, { campaignType, biddingStrategy } = {}) => {
    const params = new URLSearchParams()
    if (campaignType) params.append('campaign_type', campaignType)
    if (biddingStrategy) params.append('bidding_strategy', biddingStrategy)
    const query = params.toString()
    const endpoint = `/integrations/connect/google/assets/${customerId}/conversions${
      query ? `?${query}` : ''
    }`
    const response = await makeApiRequest(api, 'get', endpoint)
    const { data, error, status } = unwrapEnvelope(response)
    if (status === 200) {
      return { data: mapConversionGoalsResponse(data), status }
    }
    return { error, status }
  },
}

export default googleConversionGoalsApi
